import React, {ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import AnnotationRectangle from "./AnnotationRectangle";
import {Annotation, MetadataRectangle} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class WidgetAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 popupContent={annotation.contents} creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				<svg xmlns={SVG_NAMESPACE}>
					<rect x={0} y={0} width={rectBoundaries.width} height={rectBoundaries.height}/>
				</svg>
			</AnnotationRectangle>
		);
	}
}